import { Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import type { ColumnType } from "antd/es/table";

export const createAntdFilter = <T extends object>(
  dataIndex: keyof T,
  label?: string,
  onSearch?: (value: string, recordValue: any) => boolean
): ColumnType<T> => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
  }) => (
    <div style={{ padding: 8 }}>
      <Input
        placeholder={`Search ${String(label || dataIndex)}`}
        value={selectedKeys[0] as string}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => confirm()}
        style={{ marginBottom: 8, display: "block" }}
      />
      <Button
        type="primary"
        onClick={() => confirm()}
        icon={<SearchOutlined />}
        size="small"
        // <Button color="default" variant="filled">
        color="default"
        variant="text"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button
        onClick={() => {
          clearFilters && clearFilters();
          confirm();
        }}
        size="small"
        color="default"
        variant="text"
        style={{ width: 90 }}
      >
        Reset
      </Button>
    </div>
  ),
  filterIcon: (filtered: boolean) => (
    <SearchOutlined
      style={{ color: filtered ? "rgba(40, 19, 87, 1)" : undefined }}
    />
  ),
  onFilter: onSearch
    ? (value, record) => onSearch(value as string, record[dataIndex])
    : (value, record) =>
        record[dataIndex]
          ? String(record[dataIndex])
              .toLowerCase()
              .includes((value as string).toLowerCase())
          : false
});
